import axios from '../axios'

const patchFeedbackEventApi = async (eventId, feedback) => {
    return await axios.patch(`api/teacher/events/${eventId}/feedback`, { feedback })
}

export default patchFeedbackEventApi
